export function formatAuthor(str, taille) {
  str = str==null ? "...": str;
    if (str.length > taille) {
      return str.substring(0, taille) + '...';
    } else {
      return str.padEnd(taille, ' ');
    }
};

export function formatTitle (str, charsPerLine){
    if (str.length > charsPerLine * 3) {
      const lines = [
        str.substring(0, charsPerLine),
        str.substring(charsPerLine, charsPerLine * 2),
        str.substring(charsPerLine * 2, charsPerLine * 3) + '...'
      ];
      return lines.join('\n');
    } else {
      const lines = [
        str.substring(0, Math.min(charsPerLine, str.length)).padEnd(charsPerLine, ' '),
        str.substring(charsPerLine, Math.min(charsPerLine * 2, str.length)).padEnd(charsPerLine, ' '),
        str.substring(charsPerLine * 2, Math.min(charsPerLine * 3, str.length)).padEnd(charsPerLine, ' ')
      ];
      return lines.join('\n');
    }
}